export enum ChecklistItemType {
  HideChecklistItems,
  LoginCode,
  AppMention,
  Theme,
  Organisation,
  Welcome,
  Program,
  Information,
  RSVP,
  Gifts,
  Secret
}
